import { Factory, QuickFactory } from '@infodata-group/inf-commons';
import { FleetDriver } from '../model/fleet-driver';
import { FleetDriverDto } from '../interface/fleet-driver.dto';
import dayjs from 'dayjs';

export class FleetDriverFactory
  extends QuickFactory
  implements Factory<FleetDriver>
{
  private bbxId: string;

  constructor(bbxId?: string) {
    super();
    this.bbxId = bbxId;
  }

  build(o: FleetDriverDto): FleetDriver {
    const fleetDriver: FleetDriver = new FleetDriver(o.id);
    this.generateProperty(fleetDriver, o);
    fleetDriver.date = o.date ?? dayjs(new Date()).format('DD-MM-YYYY');

    return fleetDriver;
  }

  getApi(): string {
    return this.bbxId
      ? `administration/fleet/${this.bbxId}/drivers/`
      : 'administration/fleet/drivers';
  }
}
